import { render, staticRenderFns } from "./rejectedDialog.vue?vue&type=template&id=bcf2b28e&scoped=true"
import script from "./rejectedDialog.vue?vue&type=script&lang=js"
export * from "./rejectedDialog.vue?vue&type=script&lang=js"
import style0 from "./rejectedDialog.vue?vue&type=style&index=0&id=bcf2b28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2b28e",
  null
  
)

export default component.exports